export default function IconInfo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.500001 2.96243 2.96243 0.499999 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z"
        fill="#8D8D8D"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6 8.5C5.72386 8.5 5.5 8.27614 5.5 8L5.5 6C5.5 5.72386 5.72386 5.5 6 5.5C6.27614 5.5 6.5 5.72386 6.5 6L6.5 8C6.5 8.27614 6.27614 8.5 6 8.5Z"
        fill="#8D8D8D"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M6.5 4C6.5 4.27614 6.27614 4.5 6 4.5L5.995 4.5C5.71886 4.5 5.495 4.27614 5.495 4C5.495 3.72386 5.71886 3.5 5.995 3.5L6 3.5C6.27614 3.5 6.5 3.72386 6.5 4Z"
        fill="#8D8D8D"
        fillRule="evenodd"
      />
    </svg>
  )
}
